import React, { useState } from "react";
import { Typography, Input, Collapse, Button, Modal } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  Container,
  LogrosCard,
  LogrosHeader,
  LogrosContent,
  BackButton,
} from "./styles";
import styled from 'styled-components';
import { useListarLogros } from "../../../Hooks/Player";

const { Title } = Typography;
const { Panel } = Collapse;

export const LogrosScreen = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLogro, setSelectedLogro] = useState(null);
  const [activeKey, setActiveKey] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const ButtonContainer = styled.div`
    display: flex; 
  flex-wrap: wrap; 
  justify-content: center; 
  gap: 10px; 
  margin: 20px 0; 
  max-height: 200px; 
  overflow-y: auto; 
  `;

  const showModal = (logro) => {
    setSelectedLogro(logro);
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const {data, refetch, isFetching} = useListarLogros();

  const prueba = {
    Medallas: [
      {
        nombre: "Medalla Agua",
        descripcion: "Medalla entregada al derrotar el gimnasio de Agua de Kanto",
        imagen: "https://images.wikidexcdn.net/mwuploads/wikidex/thumb/6/60/latest/20180812013531/Medalla_Cascada.png/180px-Medalla_Cascada.png",
        tipoLogro: "Medalla",
        idTipoLogro: 1,
      },
  
    ],
    Torneos: [
      {
        nombre: "Logro de prueba",
        descripcion: "prueba",
        imagen: "https://images.wikidexcdn.net/mwuploads/wikidex/thumb/6/60/latest/20180812013531/Medalla_Cascada.png/180px-Medalla_Cascada.png",
        tipoLogro: "Torneo",
        idTipoLogro: 2,
      },
    ],
    Aventuras: [],
  };

  const onCollapseChange = (key) => {
    setActiveKey([key[key.length - 1]]);
  };

  return (
    <Container>
      <BackButton
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate("/configuracion")}
      />

      <LogrosHeader>
        <Title level={2} style={{fontFamily: "POKEFONT"}}>Logros</Title>
       {/*  <Input
          placeholder="Buscar..."
          value={search}
          onChange={handleSearchChange}
          style={{ width: "100%", marginBottom: "20px" }}
        /> */}
      </LogrosHeader>

      <LogrosCard>
        <Collapse activeKey={activeKey} onChange={onCollapseChange}>
          <Panel style={{ color: "#FFFF" }} header="Medallas" key="1">
            <LogrosContent>
              <ButtonContainer>
                {data && data.Medallas.map((item) => (
                  <Button key={item.nombre} onClick={() => showModal(item)}>
                    {item.nombre}
                  </Button>
                ))}
              </ButtonContainer>
            </LogrosContent>
          </Panel>
          <Panel header="Torneos" key="2">
            <LogrosContent>
              <ButtonContainer>
                {data && data.Torneos.map((item) => (
                  <Button key={item.nombre} onClick={() => showModal(item)}>
                    {item.nombre}
                  </Button>
                ))}
              </ButtonContainer>
            </LogrosContent>
          </Panel>
          <Panel header="Otros" key="3">
            <LogrosContent>
              <ButtonContainer>
                {data && data.Aventuras.map((item) => (
                  <Button key={item.nombre} onClick={() => showModal(item)}>
                    {item.nombre}
                  </Button>
                ))}
              </ButtonContainer>
            </LogrosContent>
          </Panel>
        </Collapse>
      </LogrosCard>

     
      <Modal
        visible={isModalVisible}
        footer={null}
        closable={false}
        onCancel={handleClose}
        className="custom-modal"
        style={{
          backgroundColor: "transparent",
          padding: "10px",
        }}
      >
        {selectedLogro && (
          <div style={{ padding: "20px", borderRadius: "10px" }}>
            <img
              src={selectedLogro.imagen}
              alt={selectedLogro.nombre}
              style={{ width: "100%" }}
            />
            <p
              style={{
                color: "#FFF",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "1.2rem",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              "{selectedLogro.descripcion}"
            </p>
          </div>
        )}
      </Modal>
    </Container>
  );
};
